import { render } from "./MenuTile.vue?vue&type=template&id=4ad7ac67&scoped=true&ts=true"
import script from "./MenuTile.vue?vue&type=script&lang=ts"
export * from "./MenuTile.vue?vue&type=script&lang=ts"

import "./MenuTile.vue?vue&type=style&index=0&id=4ad7ac67&scoped=true&lang=css"

import exportComponent from "/Users/david/Documents/repos/fancypools-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad7ac67"]])

export default __exports__